// Sip Theory product catalog — real products matching brand range posters.
// Images are generated via Gemini Nano Banana and served by FastAPI at /api/static/products/<id>.png

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const img = (id) => `${BACKEND_URL}/static/products/${id}.png`;
const range = (file) => `${BACKEND_URL}/api/static/ranges/${file}`;

export const RANGE_IMAGES = {
  shakes:           range('shakes.jpg'),
  'fruit-shakes':   range('fruit-shakes.jpg'),
  'cold-coffee':    range('cold-coffee.jpg'),
  'water-range':    range('flavoured-water.jpg'),
  'ice-tea':        range('ice-tea.jpg'),
};

export const FEATURES = [
  { key: 'real-ingredients', label: 'Real Ingredients', desc: 'Only real fruits, nuts & herbs', icon: 'Leaf' },
  { key: 'no-added-sugar',   label: 'No Added Sugar',   desc: 'Naturally sweet, never artificial', icon: 'Candy' },
  { key: 'refrigerated',     label: 'Refrigerated & Fresh', desc: 'Keeps it fresh, keeps you healthy', icon: 'Snowflake' },
  { key: 'made-with-love',   label: 'Made With Love',   desc: 'Thoughtfully crafted for you', icon: 'Heart' },
  { key: 'good-for-you',     label: 'Good For You',     desc: 'Better choices for a better you', icon: 'Sparkles' },
];

export const CATEGORIES = [
  { slug: 'shakes',       name: 'Shakes Range',          tagline: 'Rich & Creamy',         tone: '#8a6ea2', heroImage: range('shakes.jpg') },
  { slug: 'fruit-shakes', name: 'Fruit Shakes',          tagline: 'Fruity & Refreshing',   tone: '#d39646', heroImage: range('fruit-shakes.jpg') },
  { slug: 'cold-coffee',  name: 'Cold Coffee',           tagline: 'Energetic & Bold',      tone: '#5b3a1f', heroImage: range('cold-coffee.jpg') },
  { slug: 'water-range',  name: 'Flavoured Water',       tagline: 'Hydrating & Light',     tone: '#c97b87', heroImage: range('flavoured-water.jpg') },
  { slug: 'ice-tea',      name: 'Ice Tea Range',         tagline: 'Refreshing & Light',    tone: '#c08a3a', heroImage: range('ice-tea.jpg') },
];

export const PRODUCTS = [
  // ── Shakes ──
  { id: 'chocolate-shake',     name: 'Chocolate Shake',     category: 'shakes',       price: 220, volume: '250 ml',
    tagline: 'Rich. Creamy. Irresistible.',
    description: 'Made with premium cocoa and real chocolate, slow-blended into a velvet smooth indulgence.',
    image: img('chocolate-shake'), accent: '#c89265', bestseller: true },
  { id: 'vanila-shake',        name: 'Vanila Shake',        category: 'shakes',       price: 220, volume: '250 ml',
    tagline: 'Soft. Floral. Familiar.',
    description: 'Madagascar vanilla pods steeped in milk for a clean, classic, never-cloying vanilla.',
    image: img('vanila-shake'),   accent: '#e6d3a8' },
  { id: 'butter-scotch-shake', name: 'Butter Scotch Shake', category: 'shakes',       price: 220, volume: '250 ml',
    tagline: 'Buttery. Toasted. Smooth.',
    description: 'Hand-poured caramel and butter notes melted into a deeply comforting shake.',
    image: img('butter-scotch-shake'), accent: '#d4a76a' },
  { id: 'black-current-shake', name: 'Black Current Shake', category: 'shakes',       price: 240, volume: '250 ml',
    tagline: 'Bold. Dark. Mysterious.',
    description: 'Deep blackcurrants pressed into a faintly tart, beautifully purple shake.',
    image: img('black-current-shake'), accent: '#a786d6' },
  { id: 'oreo-magic-shake',    name: 'Oreo Magic Shake',    category: 'shakes',       price: 240, volume: '250 ml',
    tagline: 'Cookies & cream done right.',
    description: 'Real chocolate cookie pieces churned into a creamy, dreamy milkshake.',
    image: img('oreo-magic-shake'), accent: '#b7aea3' },

  // ── Fruit Shakes ──
  { id: 'mango-fruit-shake',     name: 'Mango Fruit Shake',     category: 'fruit-shakes', price: 220, volume: '250 ml',
    tagline: 'Sun-ripened sweetness.',
    description: 'Alphonso mangoes blended with farm milk — a tropical embrace in every bottle.',
    image: img('mango-fruit-shake'), accent: '#f0b04a' },
  { id: 'strawberry-fruit-shake',name: 'Strawberry Fruit Shake',category: 'fruit-shakes', price: 220, volume: '250 ml',
    tagline: 'Vivid. Tart. Vivid.',
    description: 'Real strawberries, gently mashed and folded into a soft pink shake.',
    image: img('strawberry-fruit-shake'), accent: '#e89cb4' },
  { id: 'mix-berry-fruit-shake', name: 'Mix Berry Fruit Shake', category: 'fruit-shakes', price: 240, volume: '250 ml',
    tagline: 'Wild berries, all together.',
    description: 'Strawberries, blueberries and blackberries blended into a creamy berry symphony.',
    image: img('mix-berry-fruit-shake'), accent: '#c47ea3', bestseller: true },
  { id: 'banana-fruit-shake',    name: 'Banana Fruit Shake',    category: 'fruit-shakes', price: 200, volume: '250 ml',
    tagline: 'Creamy. Honest. Wholesome.',
    description: 'Ripe bananas, milk and a hint of cinnamon — a glass of comfort.',
    image: img('banana-fruit-shake'), accent: '#f5d775' },

  // ── Flavoured Water ──
  { id: 'strawberry-water', name: 'Strawberry Water', category: 'water-range', price: 160, volume: '250 ml',
    tagline: 'Petal-soft. Lightly sweet.',
    description: 'Himalayan spring water gently infused with strawberry slices and mint.',
    image: img('strawberry-water'), accent: '#e6a4ad' },
  { id: 'watermelon-water', name: 'Water Melon Water', category: 'water-range', price: 160, volume: '250 ml',
    tagline: 'Cool, juicy, refreshing.',
    description: 'Cold-pressed watermelon water — pure hydration with a clean, sweet finish.',
    image: img('watermelon-water'), accent: '#e87a7a' },
  { id: 'lemon-water',      name: 'Lemon Water',      category: 'water-range', price: 150, volume: '250 ml',
    tagline: 'Bright. Crisp. Clean.',
    description: 'Cold-pressed lemon and basil, lightly infused into spring water.',
    image: img('lemon-water'), accent: '#f0d56a' },
  { id: 'cucumber-water',   name: 'Cucumber Water',   category: 'water-range', price: 150, volume: '250 ml',
    tagline: 'Crisp. Cooling. Calm.',
    description: 'Garden cucumbers + mint, slow infused into mountain spring water.',
    image: img('cucumber-water'), accent: '#bcd49a' },

  // ── Cold Coffee ──
  { id: 'classic-cold-coffee',  name: 'Classic Cold Coffee',  category: 'cold-coffee', price: 240, volume: '250 ml',
    tagline: 'Smooth. Mellow. Iconic.',
    description: '18-hour cold brew arabica with farm milk — the everyday classic.',
    image: img('classic-cold-coffee'), accent: '#b08a5e' },
  { id: 'hazelnut-cold-coffee', name: 'Hazelnut Cold Coffee', category: 'cold-coffee', price: 260, volume: '250 ml',
    tagline: 'Nutty, warm, indulgent.',
    description: 'Cold brew with roasted hazelnut praline for a quietly indulgent sip.',
    image: img('hazelnut-cold-coffee'), accent: '#a06d3c' },

  // ── Ice Tea ──
  { id: 'peach-ice-tea', name: 'Peach Ice Tea', category: 'ice-tea', price: 180, volume: '250 ml',
    tagline: 'Sun-warm. Tea-cool.',
    description: 'Black tea slow steeped with white peach — perfectly balanced, no added sugar.',
    image: img('peach-ice-tea'), accent: '#e3a86c' },
  { id: 'lemon-ice-tea', name: 'Lemon Ice Tea', category: 'ice-tea', price: 180, volume: '250 ml',
    tagline: 'Zest, brew, repeat.',
    description: 'Hand-pressed lemons over slow-brewed black tea, lightly chilled.',
    image: img('lemon-ice-tea'), accent: '#e8c25c' },
];

export const COLLECTIONS = [
  { slug: 'morning-ritual',  name: 'The Morning Ritual',   desc: 'Slow brews and gentle wakes',          tone: '#6b4327',
    image: range('cold-coffee.jpg'),     productIds: ['classic-cold-coffee','hazelnut-cold-coffee','banana-fruit-shake'] },
  { slug: 'post-workout',    name: 'Post-Workout Recovery', desc: 'Protein, fruit and electrolytes',     tone: '#aab87c',
    image: range('fruit-shakes.jpg'),    productIds: ['banana-fruit-shake','mango-fruit-shake','mix-berry-fruit-shake'] },
  { slug: 'sunset-sips',     name: 'Sunset Sips',           desc: 'Fruit-forward, evening light',        tone: '#d39646',
    image: range('fruit-shakes.jpg'),    productIds: ['mango-fruit-shake','strawberry-fruit-shake','peach-ice-tea'] },
  { slug: 'hydration-edit',  name: 'The Hydration Edit',    desc: 'Infused waters & light sips',         tone: '#c47888',
    image: range('flavoured-water.jpg'), productIds: ['cucumber-water','lemon-water','strawberry-water','watermelon-water'] },
  { slug: 'midnight-indulge',name: 'Midnight Indulgence',   desc: 'Chocolate, coffee, after dark',       tone: '#3a2855',
    image: range('shakes.jpg'),          productIds: ['chocolate-shake','oreo-magic-shake','black-current-shake'] },
  { slug: 'tea-house',       name: 'The Tea House',         desc: 'Slow brewed tea, kept cold',          tone: '#c08a3a',
    image: range('ice-tea.jpg'),         productIds: ['peach-ice-tea','lemon-ice-tea'] },
];

export const POSTS = [
  { slug: 'why-cold-chain-matters', title: 'Why Cold Chain Matters For Real Ingredients',
    excerpt: 'The science behind keeping our beverages refrigerated from kitchen to your hand.',
    readTime: '4 min read', date: 'Jan 12, 2026', category: 'Process',
    cover: range('cold-coffee.jpg') },
  { slug: 'art-of-no-added-sugar', title: 'The Art Of No Added Sugar',
    excerpt: 'How fruits, dates and honest fermentation can carry sweetness on their own.',
    readTime: '6 min read', date: 'Jan 04, 2026', category: 'Nutrition',
    cover: range('fruit-shakes.jpg') },
  { slug: 'sip-theory-origin', title: 'The Origin Of Sip Theory',
    excerpt: 'A kitchen experiment, a few honest recipes, and the belief that goodness should taste good.',
    readTime: '5 min read', date: 'Dec 20, 2025', category: 'Story',
    cover: range('shakes.jpg') },
  { slug: 'desi-classics-modern-format', title: 'Desi Classics In A Modern Format',
    excerpt: 'How we reimagined classic Indian drinks for today\'s on-the-go life.',
    readTime: '7 min read', date: 'Dec 02, 2025', category: 'Craft',
    cover: range('flavoured-water.jpg') },
];
